import React, { useState, useEffect } from 'react';
import ProjectModal from './ProjectModal';
import classes from './Project.module.css';
import Tilt from 'react-parallax-tilt';
// import "ParallaxEffectImg.demotab.scss";
import AOS from 'aos';
import 'aos/dist/aos.css';

const Project = props => {
  const [show, setShow] = useState(false);
  const { title, imageSrc, color, width, height } = props.project;

  const showHandler = () => {
    setShow(true);
  };
  const hideHandler = () => {
    setShow(false);
  };

  useEffect(() => {
    AOS.init({
      // once: true,
      duration: 1000
    });
  });

  return (
    <>
      {show && <ProjectModal onClose={hideHandler} items={props.project} />}
      <div className={classes['project-items']} onClick={showHandler}>
        <div data-aos={'fade-up'} className={classes['project-container']}>
          <Tilt
            tiltMaxAngleX={40}
            tiltMaxAngleY={40}
            perspective={800}
            glareColor="#fff"
            glareEnable={true}
            glareMaxOpacity={0.7}
            glareBorderRadius="20px"
            glarePosition="all"
            gyroscope={true}
          >
            <div
              style={{ background: color }}
              className={classes['project-item']}
            >
              <Tilt perspective={1000}>
                {' '}
                {/*//trackOnWindow={true} */}
                <img
                  className={classes.img}
                  style={{ width: width, height: height }}
                  src={imageSrc}
                  alt="img"
                />
              </Tilt>
            </div>
          </Tilt>
          <h1 className={classes['project-name']}>{title}</h1>
        </div>
      </div>
    </>
  );
};

export default Project;
